import React from 'react';

const Home: React.FC = () => {
  return <div>ダッシュボード</div>;
};

export default Home;
